/**
 * @generated SignedSource<<53bf569fe39681d7685d2ed11fa0fb40>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrgFeatures = "ANALYTICS" | "FILES" | "MAP" | "PRODUCTS" | "ROUTINES" | "SIGNALS" | "SPACES" | "TODOS";
export type StoreTier = "basic" | "free" | "light" | "premium" | "standard" | "unlimited";
export type OrgStoresQuery$variables = {
  includeMapData: boolean;
  workspaceId: string;
};
export type OrgStoresQuery$data = {
  readonly organisation: {
    readonly features: ReadonlyArray<OrgFeatures>;
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"OrgStoresMapActiveUsers_organisation">;
  } | null;
  readonly workspace: {
    readonly stores: ReadonlyArray<{
      readonly externalId: string | null;
      readonly id: string;
      readonly name: string;
      readonly tier: StoreTier;
      readonly timezone: string;
      readonly workspaceBreadcrumbs: ReadonlyArray<string>;
      readonly " $fragmentSpreads": FragmentRefs<"OrgStoreWorkspaceBreadcrumbs_store" | "OrgStoresMap_stores">;
    }>;
  };
};
export type OrgStoresQuery = {
  response: OrgStoresQuery$data;
  variables: OrgStoresQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeMapData"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "features",
  "storageKey": null
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "workspaceId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tier",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timezone",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "belowWorkspaceId",
      "variableName": "workspaceId"
    },
    {
      "kind": "Literal",
      "name": "includeExternalId",
      "value": true
    }
  ],
  "kind": "ScalarField",
  "name": "workspaceBreadcrumbs",
  "storageKey": null
},
v10 = [
  (v2/*: any*/),
  (v5/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "OrgStoresQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Organisation",
        "kind": "LinkedField",
        "name": "organisation",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "condition": "includeMapData",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "OrgStoresMapActiveUsers_organisation"
              }
            ]
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Store",
            "kind": "LinkedField",
            "name": "stores",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v2/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "currentWorkspaceId",
                    "variableName": "workspaceId"
                  }
                ],
                "kind": "FragmentSpread",
                "name": "OrgStoreWorkspaceBreadcrumbs_store"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "OrgStoresMap_stores"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "OrgStoresQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Organisation",
        "kind": "LinkedField",
        "name": "organisation",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "condition": "includeMapData",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RecentlyActiveUser",
                "kind": "LinkedField",
                "name": "recentlyActiveUsers",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": (v10/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Store",
                    "kind": "LinkedField",
                    "name": "store",
                    "plural": false,
                    "selections": (v10/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Store",
            "kind": "LinkedField",
            "name": "stores",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v2/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "latitude",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "longitude",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastActiveAt",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "53673bcc8eaebea6861d7e8052c1ebf8",
    "id": null,
    "metadata": {},
    "name": "OrgStoresQuery",
    "operationKind": "query",
    "text": "query OrgStoresQuery(\n  $workspaceId: ID!\n  $includeMapData: Boolean!\n) {\n  organisation {\n    name\n    features\n    ...OrgStoresMapActiveUsers_organisation @include(if: $includeMapData)\n    id\n  }\n  workspace(id: $workspaceId) {\n    stores {\n      id\n      name\n      tier\n      timezone\n      externalId\n      workspaceBreadcrumbs(belowWorkspaceId: $workspaceId, includeExternalId: true)\n      ...OrgStoreWorkspaceBreadcrumbs_store_1xnmrJ\n      ...OrgStoresMap_stores\n    }\n    id\n  }\n}\n\nfragment Avatar_user on User {\n  name\n}\n\nfragment OrgStoreWorkspaceBreadcrumbs_store_1xnmrJ on Store {\n  workspaceBreadcrumbs(belowWorkspaceId: $workspaceId, includeExternalId: true)\n}\n\nfragment OrgStoresMapActiveUsers_organisation on Organisation {\n  recentlyActiveUsers {\n    id\n    user {\n      name\n      ...Avatar_user\n      id\n    }\n    store {\n      name\n      id\n    }\n  }\n}\n\nfragment OrgStoresMap_stores on Store {\n  id\n  name\n  latitude\n  longitude\n  lastActiveAt\n}\n"
  }
};
})();

(node as any).hash = "e9846d32d469661dd1604d681dee1054";

export default node;
